import { render, staticRenderFns } from "./ProjectContractorsCardItem.vue?vue&type=template&id=83bf78c6"
import script from "./ProjectContractorsCardItem.vue?vue&type=script&lang=ts"
export * from "./ProjectContractorsCardItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83bf78c6')) {
      api.createRecord('83bf78c6', component.options)
    } else {
      api.reload('83bf78c6', component.options)
    }
    module.hot.accept("./ProjectContractorsCardItem.vue?vue&type=template&id=83bf78c6", function () {
      api.rerender('83bf78c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/projects/ProjectContractorsCardItem.vue"
export default component.exports